import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { MapComponent } from '../../../shared/components/map/map.component';

@Component({
  selector: 'app-responsible-contact-details',
  templateUrl: './responsible-contact-details.component.html',
  styleUrls: ['./responsible-contact-details.component.scss'],
  standalone: true,
  imports: [CommonModule, MapComponent],
})
export class ResponsibleContactDetailsComponent implements OnInit {
  @Input() showTaxNumber = false;
  @Input() showBusinessInfo = false;
  @Input() showMessenger = false;
  @Input() showMap = false;
  @Input() lat = environment.homeLatitude;
  @Input() lng = environment.homeLongitude;

  constructor() {}

  ngOnInit(): void {}
}
